import { Box, Tab, styled } from '@mui/material';
import { themeColors } from 'src/theme';

export const StyledTab = styled(Tab)(({ theme }) => ({
  width: '33%',
  textTransform: 'none',
  fontSize: '16px',
  color: themeColors.grayDark,
  whiteSpace: 'nowrap',
  '&.Mui-selected': {
    color: 'black',
  },
  [theme.breakpoints.up('md')]: {
    width: 'auto',
  },
}));

export const TabsContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
}));

export const PendingContractorsTab = styled(Box)({
  gap: '24px',
  display: 'flex',
  flexDirection: 'column',
});
